// extracted by mini-css-extract-plugin
export default {"form":"createCategory_form__vcXJ-","formInputBlock":"createCategory_formInputBlock__8ZS7l","formInput":"createCategory_formInput__ACWh7"};